import _ from 'lodash';
import moment from 'moment';
import React, { useEffect } from 'react';
import { api, app, use } from 'xadmin';
import { message } from 'antd';
import sha1 from 'crypto-js/sha1'
import permissions from './permissions.json'

const getUrlParms = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let href = window.location.href.substr(window.location.href.indexOf('?'))
  let r = href.substr(1).match(reg);
  if (r != null)
    return unescape(r[2]);
  return null;
}

const mergeSchema = (newSchema, userExpand) => {
  for (let key of _.keys(userExpand?.properties || [])) {
    if (newSchema?.properties && userExpand.properties) {
      newSchema.properties[key] = userExpand.properties[key]
      newSchema.properties[key].user = 'expand'
      if (!newSchema?.form?.find(i => key === i)) {
        newSchema.form.push(key)
        if (newSchema.properties[key]?.filterFields) {
          newSchema.filters.submenu.push(key)
        }
      }
    }
  }
  if (newSchema?.required && userExpand?.required) {
    newSchema.required = [...(newSchema?.required || []), ...(userExpand?.required || [])]
  }
  return newSchema
}

const getAllPermissions = async () => {
  const models = app.get('models')
  let newData, allPermissions = [], promiseArray = [], tableData = [], dashboardData = [];
  //工作表权限
  if (Object.keys(models).indexOf('Table') > -1) {
    promiseArray.push(new Promise((resolve, reject) => {
      api({ name: '/core/table' }).query({ fields: ['schema'] }, {})
        .then(({ items }) => {
          const newData = _.compact(items.map(opt => ({ schema: opt.schema, name: opt.name }))).map(model => {
            const name = (model.name)
            const rolePermission = model.rolePermission || [
              { key: `ext_${name}.view`, title: '查看' },
              { key: `ext_${name}.add`, title: '创建' },
              { key: `ext_${name}.edit`, title: '修改' },
              { key: `ext_${name}.delete`, title: '删除' },
            ]
            return {
              key: 'ext_' + name, title: name, children: [
                ...rolePermission,
                ...(permissions[name] ? permissions[name].children : [])
              ]
            }
          })
          resolve({ newData, status: 'success' })
        }).catch(err => {
          resolve({ err, status: 'fail' })
        })
    })
    )
  }
  if (Object.keys(models).indexOf('Dashboard') > -1) {
    const fields = ["name", "type", "cover", "focus", "isDelete"]
    const wheres = { isDelete: { "$ne": true } }
    promiseArray.push(new Promise((resolve, reject) => {
      api({ name: 'core/dashboard' }).query({ fields }, { wheres }).then(({ items }) => {
        const newData = _.compact(items.map(opt => ({ name: opt.name, id: opt?.id }))).map(model => {
          const name = (model.id)
          const rolePermission = model.rolePermission || [
            { key: `dashboard_${model?.id}.view`, title: '查看' },
            { key: `dashboard_${model?.id}.edit`, title: '修改' },
            { key: `dashboard_${model?.id}.delete`, title: '删除' },
          ]
          return {
            key: 'dashboard_' + name, title: model?.name, children: [
              ...rolePermission,
              ...(permissions[name] ? permissions[name].children : [])
            ]
          }
        })
        resolve({ newData, status: 'success' })
      }).catch(err => {
        resolve({ err, status: 'fail' })
      })
    }))
  }
  Promise.all(promiseArray).then(res => {
    let resData = res && res.map((item, index) => {
      if (item.status == 'success') {
        return item?.newData || []
      } else if (item.status == 'fail') {
        return item?.newData || []
      }
    })
    tableData = resData?.[0]
    dashboardData = resData?.[1]
  })
  const modelPermission = Object.values(models)
    .filter(model => (model.name || model.title) && (model.name || model.title).indexOf('auth_') != 0)
    .map(model => {
      const name = (model.name)?.toLowerCase()
      const rolePermission = model.rolePermission || [
        { key: `${name}.view`, title: '查看' },
        { key: `${name}.add`, title: '创建' },
        { key: `${name}.edit`, title: '修改' },
        { key: `${name}.delete`, title: '删除' },
      ]
      return {
        key: name, title: model.title, children: [
          ...rolePermission,
          ...(permissions[name] ? permissions[name].children : [])
        ]
      }

    })

  const defPermission = Object.keys(permissions).filter(key => models[key] == undefined).map(key => ({
    ...permissions[key],
    key
  }))

  // 视频权限
  const videoPermission = [['camera', '视频监控地址'], ['play', '视频监控播放'], ['live', '视频监控连接']].map(k => {
    return {
      key: k[0],
      title: k[1],
      children: [
        { key: `${k[0]}.view`, title: '查看' },
        { key: `${k[0]}.add`, title: '创建' },
        { key: `${k[0]}.edit`, title: '修改' },
        { key: `${k[0]}.delete`, title: '删除' },
      ]
    }
  })
  const permission = modelPermission.concat(defPermission).concat(videoPermission).concat(tableData).concat(dashboardData)
  const booleanPermission = permission.filter(v => Boolean(v))
  if (booleanPermission?.length) {
    booleanPermission.forEach(val => {
      val?.children?.length && val.children.forEach(item => {
        allPermissions.push(item?.key)
      })
    })
  }
  return allPermissions
}

const uploadUser = (value, json, locaPathname, arr, dispatch) => {
  if (value?.remenber) {
    arr.forEach(item => localStorage.setItem(item, JSON.stringify({ ...json, time: moment().unix() })))
  } else {
    const sessionArr = [`user${locaPathname}`, `user/${value.username}${locaPathname}`]
    sessionArr.forEach(item => {
      // try {
      sessionStorage.setItem(item, JSON.stringify({ ...json, time: moment().unix() }))
      // } catch (e) {
      //   if (e.name.toUpperCase().indexOf('QUOTA') >= 0) {
      //     let arr = [`user${locaPathname}`, `user/${value.username}${locaPathname}`, `${locaOrigin}/${value.username}`]
      //     // 删除缓存时间最早的
      //     sessionStorage.removeItem(arr[0]);
      //     sessionStorage.removeItem(arr[2]);
      //   }
      // }
    })
  }
  localStorage.setItem('resetCode', false)

  if (json?.pwdTimeouttime) {
    localStorage.setItem(`${json.username}${locaPathname}pwdTimeouttime`, json?.pwdTimeouttime)
    sessionStorage.setItem(`${json.username}${locaPathname}pwdTimeouttime`, json?.pwdTimeouttime)
  }
  dispatch({ type: '@@xadmin/AUTH_SIGN_IN', payload: json })
  dispatch({ type: '@@xadmin/GET_USER_INFO', payload: json, success: true })
  dispatch({ type: '@@xadmin/LOAD_VARIABLE' })
}

export default {
  'auth.user': props => {
    const { dispatch, user } = use('redux', state => ({ user: state.user }))
    const { host } = window.location

    const onLogout = () => {
      dispatch({ type: '@@xadmin/AUTH_SIGN_OUT' })
      // 添加退出操作日志
      api({ name: 'core/auth/logout' }).fetch('')
      // 清除空间管理储存的token
      sessionStorage.removeItem('portal_login')
      sessionStorage.removeItem(`${host}_portal_token`)

    }
    const onChangePassword = () => {
      app.go('/app/change_password')
    }
    return { ...props, user, onLogout, onChangePassword }
  },
  'auth.login': props => {
    const { location: { query } } = props
    const { dispatch } = use('redux')
    const { settings } = use('settings')
    const [showCode, setShowCode] = React.useState(false)
    const showExtra = false
    let showCodesetting = settings?.notShowCodeAdmin

    const getTokenSettings = (token) => {
      if (!token) return
      const headers = api({ name: '' }).getHeaders()
      // 登录后获取settings
      api({ name: 'core/setting' }).fetch('', {
        headers: { ...headers, 'Authorization': token, }
      }).then(({ json }) => {
        app.context?.store?.dispatch({ type: '@@iot/SAVE_SETTINGS', payload: json, success: true })
      })
    }


    const onSubmit = (value) => {

      if (!showCodesetting && showCode && _.isEmpty(value.code)) { message.info('验证码不能为空！'); return }
      let data = { ...value, code: value.code, password: sha1(value.password).toString(), username: value.username }
      let name = getUrlParms('name')
      let client_id = getUrlParms('client_id')
      let redirect_uri = getUrlParms('redirect_uri')
      let platform_uri = getUrlParms('platform_uri')
      let response_type = getUrlParms('response_type')
      let return_to = getUrlParms('return_to')
      let state = getUrlParms('state')
      let projectId = getUrlParms('x-request-project')
      let obj = { client_id, redirect_uri, platform_uri, response_type, return_to, state }
      if (name) { obj = { ...obj, name } }
      if (projectId) { obj = { ...obj, 'x-request-project': projectId } }
      let string = ''
      if (client_id && redirect_uri && platform_uri && return_to) {
        for (let key in obj) { string = string + `${key}=${obj[key]}&` }
        string = string.substr(0, string.lastIndexOf('&') - 1)
      }
      return new Promise((resolve, reject) => {
        api({ name: string ? `core/auth/login?${string}` : 'core/auth/login' })
          .fetch('', {
            method: 'POST',
            body: JSON.stringify(data),
          })
          .then(res => {
            let { json, headers } = res
            let redirect = headers['x-oauth-redirect']
            // 登录后获取settings
            getTokenSettings(json?.token)

            //登录成功
            const locaPathname = window.location.pathname
            const locaOrigin = window.location.origin
            let arr = [`user${locaPathname}`, `user/${value.username}${locaPathname}`, `${locaOrigin}/${value.username}`]
            arr.forEach(item => { localStorage.removeItem(item); sessionStorage.removeItem(item) })
            uploadUser(value, json, locaPathname, arr, dispatch)

            //处理黑名单角色权限
            if (!json?.isAdmin && json?.blackPermissions?.length) {
              getAllPermissions().then(res => {
                let mergePermission = []
                res?.length && res.forEach(val => {
                  let index = json.blackPermissions.findIndex(item => item == val)
                  if (index == -1) {
                    mergePermission.push(val)
                  }
                })
                json.permissions = mergePermission
                uploadUser(value, json, locaPathname, arr, dispatch)
              }).catch(err => {
                uploadUser(value, json, locaPathname, arr, dispatch)
              })
            }
            // 登陆后请求完成setting
            dispatch({ type: '@@iot/GET_SETTINGS' })
            let username = value.username
            let password = value.password
            let needChangePwd = settings?.userExpand?.needChangePwd && json.isFirstLogin
            const id = json.id
            if (!needChangePwd) {
              if (redirect && redirect == '#/oAuth') {
                app.go(`/oAuth?${string}`)
              } else {
                // 设置了登录后页面的情况 跳转到登录后页面
                const hasRouter = app.get('routers') && app.get('routers')['/']?.find(r => r.path == 'login_next')
                const hasLoginNextPage = settings?.rectption_login_next_page?.id && settings?.rectption_login_next_page_hangtime
                const login_next_url = query?.redirect ? `/login_next?redirect=${encodeURIComponent(query.redirect)}` : `/login_next`
                hasRouter && hasLoginNextPage ? app.go(`${login_next_url}`) : app.go(query && query.redirect || '/app/')
              }
            }

            resolve({ needChangePwd, password, id, username })
          })
          .catch((err) => {
            localStorage.setItem('resetCode', new Date())
            if (err.status !== 451) setShowCode(true)
            if (err.status == 400 || err.status == 451) {
              reject({
                ...err.json,
                username: err.json && err.json.user,
                'FORM_ERROR': err.json && err.json.user
              })
            } else {
              try {
                err?.message && _.isPlainObject(err) && Object.values(JSON.parse(err.message)).map(item => { message.error(item, item?.detail) })
                reject(err)
              } catch {
                reject(err)
              }
            }
            if (err.json?.status) {
              const closeMessage = err.json?.status
              message.error(closeMessage, err?.detail);
            }

          })
      })
    }

    return { ...props, showCode, showExtra, onSubmit }
  },
  'auth.reg': props => {
    const { location: { query } } = props
    const { dispatch } = use('redux')
    const [showCode, setShowCode] = React.useState(false)
    const showExtra = false

    const onSubmit = (value) => {
      // 注册接口调用
      let data = {
        user: value
      }
      return new Promise((resolve, reject) => {
        api({ name: 'core/register' })
          .fetch('', {
            method: 'POST',
            body: JSON.stringify({
              ...value,
              password: sha1(value.password).toString()
            }),
          })
          .then(({ json }) => {
            app.go('/login')
            // resolve()
          })
          .catch((err) => {
            if (err.status == 451) {
              message.info('已是注册用户，去登陆！')
            } else {
              message.error(err.message, err?.detail)
            }
            reject({
              ...err.json,
              username: err.json && err.json.user
            })
          })
      })
    }

    return { ...props, showCode, showExtra, onSubmit }
  },
  'auth.resetPwd': props => {
    const { location: { query } } = props
    const { dispatch } = use('redux')
    const [showCode, setShowCode] = React.useState(false)
    const showExtra = false

    const onSubmit = (value) => {
      // 修改密码接口
    }

    return { ...props, showCode, showExtra, onSubmit }
  },
  'auth.userExpand': props => {
    const { newSchema } = props
    const { settings } = use('settings')
    const { userExpand } = settings || {}

    let schema = mergeSchema(newSchema, userExpand)
    return schema
  }

}
